function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "identify_svg__a",
  x1: "104.825%",
  x2: "25.946%",
  y1: "13.519%",
  y2: "94.234%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#E4E8F2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#C9CDD9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "identify_svg__b",
  x1: "75.31%",
  x2: "25.946%",
  y1: "4.802%",
  y2: "93.563%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#E4E8F2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#C9CDD9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "identify_svg__c",
  x1: "0%",
  y1: "55.339%",
  y2: "55.339%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#00907F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#48D59F"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#identify_svg__a)",
  d: "M33.94 39.031L.403 72.503c-.54.54-.535 1.41.01 1.945l4.82 4.706a1.406 1.406 0 001.97-.011L40.741 45.67c.54-.54.535-1.41-.011-1.945l-4.82-4.706a1.397 1.397 0 00-.979-.397c-.359 0-.718.136-.99.408",
  transform: "matrix(-1 0 0 1 80 0)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#identify_svg__b)",
  d: "M24.001 28.473c.084 15.252 12.677 27.548 28.127 27.465 15.348-.083 27.742-12.353 27.822-27.467v-.3C79.866 12.971 67.356.707 51.978.706h-.156c-15.45.083-27.905 12.515-27.82 27.767z",
  transform: "matrix(-1 0 0 1 80 0)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M13.292 42.707a20.272 20.272 0 01.16-28.93c8.137-7.944 21.257-7.873 29.305.159a20.271 20.271 0 01-.16 28.929c-8.136 7.945-21.257 7.875-29.305-.158"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#identify_svg__c)",
  d: "M41.046 28.321c0 5.958 4.893 10.789 10.928 10.789 6.036 0 10.93-4.83 10.93-10.789s-4.894-10.789-10.93-10.789c-6.035 0-10.928 4.83-10.928 10.79",
  transform: "matrix(-1 0 0 1 80 0)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#111",
  d: "M33.856 28.32c0 3.178-2.61 5.756-5.83 5.756s-5.83-2.578-5.83-5.755c0-3.179 2.61-5.756 5.83-5.756s5.83 2.577 5.83 5.756"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M29.09 24.679c0-1.983 1.629-3.59 3.637-3.59s3.637 1.607 3.637 3.59c0 1.983-1.629 3.59-3.637 3.59s-3.636-1.607-3.636-3.59"
}));

function SvgIdentify(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,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";
export { SvgIdentify as ReactComponent };